import { useStyles } from "../../../theme/appStyles";
import React, { useEffect, useMemo, useRef, useState } from "react";
import {
  Box,
  Button,
  Card,
  CircularProgress,
  Dialog,
  DialogContent,
  Grid,
  IconButton,
  ImageList,
  ImageListItem,
  MenuItem,
  Step,
  StepLabel,
  Stepper,
  TextField,
  Typography,
  useMediaQuery,
} from "@mui/material";
import SaveAltIcon from "@mui/icons-material/SaveAlt";
import CloseIcon from "@mui/icons-material/Close";
import { useFormik } from "formik";
import {
useGetGameQuery, useCreateGameUnitMutation
} from "../../../Api/attoDeskApi";
import { useNotifier } from "../../../Core/Notifier";
import {
IGame
} from "../../../Api/Interface/api.interface";
import AddIcon from "@mui/icons-material/Add";
import { SizeOfLevelType } from "../../../Core/Enum/enum";
import CustomSwitch from "../../../Components/Switch/CustomSwitch";
import { styled, useTheme, Theme, CSSObject } from "@mui/material/styles";





interface IUnitPopup {
  openModel?: boolean;
  handleCloseDialog: (close: boolean) => void;
  gameId: string;
}

const Index = ({
   openModel = false,
  handleCloseDialog,
   gameId,
}: IUnitPopup ) => {

  const classes = useStyles();
  const theme = useTheme();
  const [activeStep, setActiveStep] = useState(0);
  const isMobile = useMediaQuery(theme.breakpoints.down("md"));
  const gridHeight = isMobile ? "30px" : "400px";

  const [open] = React.useState(openModel);
    const { data: gamesData } = useGetGameQuery({ searchText: ""});
    const [newLocation, { isLoading }] = useCreateGameUnitMutation();
    const { showErrorMessage, showMessage } = useNotifier();

   const games: IGame[] = Array.isArray(gamesData?.data)
        ? (gamesData?.data as IGame[])
        : [];

        const selectedGame = useMemo(() => {
  return games.find(game => String(game.id) === String(gameId));
}, [games, gameId]);



  const formik = useFormik({
   initialValues: {
    game_id: String(gameId),
    name: "",
    capacity: "",
    position_group: "",
    entry_offset_minutes: "",

     display_name:  "",
    short_description: selectedGame?.short_description || "",
    description: selectedGame?.description || "",
    pricing_type: selectedGame?.pricing_type || "",
    min_kids: selectedGame?.min_kids ?? "", // empty string if null
    max_kids: selectedGame?.max_kids ?? "",
    min_adults: selectedGame?.min_adults ?? "",
    max_adults: selectedGame?.max_adults ?? "",
    free_kids_included: selectedGame?.free_kids_included ?? "",
    free_adults_included: selectedGame?.free_adults_included ?? "",
    extra_kids_allowed: selectedGame?.extra_kids_allowed ?? false,
    extra_adults_allowed: selectedGame?.extra_adults_allowed ?? false,
    kid_price: selectedGame?.kid_price ?? "",
    adult_price: selectedGame?.adult_price ?? "",
    extra_kid_price: selectedGame?.extra_kid_price ?? "",
    extra_adult_price: selectedGame?.extra_adult_price ?? "",
    shared_capacity: selectedGame?.shared_capacity ?? "",
    max_date_changes: selectedGame?.max_date_changes ?? "",
    refund_after_changes: selectedGame?.refund_after_changes ?? false,

    isActive: true,
  },
  enableReinitialize: true,
    onSubmit: async (values, { resetForm }) => {
      try {
        const response = await newLocation(values).unwrap();
        if (!response.status) {
          showErrorMessage(response.message);
        } else {
          showMessage(response.message);
          handleCloseDialog(false);
          resetForm();
        }
      } catch (error) {
        showErrorMessage("Something went wrong");
      }
    },
  });



  const formValid = useMemo(() => {
         return  formik.values.name === "" &&
           formik.values.name === undefined
           ? false
           : true;
       }, [formik]);


       
  return (
     <Dialog
         open={open}
          fullWidth
         PaperProps={{
           style: {
             maxWidth: "1700px",
           },
         }}
          
       >
          <Grid className={classes.Dialog}>
      <Grid container spacing={3}>
       
        <Grid item lg={12} md={12} sm={12} xs={12}>
       
            <form onSubmit={formik.handleSubmit}>
                       <Grid container>
                         <Grid item lg={12} md={12} sm={12} xs={12}>
                           <Card className={classes.card}>
                             <Grid
                               container
                               justifyContent={"space-between"}
                               spacing={5}
                               sx={{ borderBottom: 2, padding: 2 }}
                               className={classes.titleGrid}
                             >
                               <Grid
                                 item
                                 lg={12}
                                 md={12}
                                 sm={12}
                                 xs={12}
                                 pt={2}
                                 alignContent={"center"}
                               >
                                 <Typography className={classes.cardTitle}>
                                   Game Unit Information
                                 </Typography>
                               </Grid>
                             </Grid>
           
                             <Grid container spacing={3} p={"24px"}>
                               {/* <Grid item lg={6} md={6} sm={12} xs={12}>
                                 <Grid container alignItems="center">
           
           
                              <Grid item lg={12} md={12} sm={12} xs={12}>
                                     <Typography variant="subtitle1">
                                        Game <span style={{ color: "red" }}>*</span>
                                     </Typography>
                                   </Grid>
                                   <Grid item lg={12} md={12} sm={12} xs={12}>
                                       <TextField
                                   select
                                   fullWidth
                                   size="small"
                                   {...formik.getFieldProps("game_id")}
                                   className={classes.textField}
                                 >
                                   <MenuItem value="">Select Game</MenuItem>
                                   {games?.map((game: IGame) => (
                                     <MenuItem key={game.id} value={game.id}>
                                       {game.name}
                                     </MenuItem>
                                   ))}
                                 </TextField>
                                   </Grid>
                                 </Grid>
                               </Grid> */}
           
           
           
           
           <Grid item lg={6} md={6} sm={12} xs={12}>
             <Grid container alignItems="center">
                                   <Grid item lg={12} md={12} sm={12} xs={12}>
                                     <Typography variant="subtitle1">
                                        Name <span style={{ color: "red" }}>*</span>
                                     </Typography>
                                   </Grid>
                                   <Grid item lg={12} md={12} sm={12} xs={12}>
                                     <TextField
                                       placeholder="Enter Name"
                                       size="small"
                                       {...formik.getFieldProps("name")}
                                       className={classes.textField}
                                       InputProps={{
                                         sx: {
                                           fontSize: 14,
                                         },
                                       }}
                                       InputLabelProps={{
                                         sx: {
                                           fontSize: 14,
                                         },
                                       }}
                                     />
                                   </Grid>
                                 </Grid>
                               </Grid>

                               
           
                              
           
           <Grid item lg={6} md={6} sm={12} xs={12}>
             <Grid container alignItems="center">
               <Grid item lg={12} md={12} sm={12} xs={12}>
                 <Typography variant="subtitle1">Capacity</Typography>
               </Grid>
               <Grid item lg={12} md={12} sm={12} xs={12}>
                 <TextField
                   type="number"
                   size="small"
                   {...formik.getFieldProps("capacity")}
                   className={classes.textField}
                 />
               </Grid>
             </Grid>
           </Grid>
           
           {/* <Grid item lg={6} md={6} sm={12} xs={12}>
             <Grid container alignItems="center">
               <Grid item lg={12} md={12} sm={12} xs={12}>
                 <Typography variant="subtitle1">Position Group</Typography>
               </Grid>
               <Grid item lg={12} md={12} sm={12} xs={12}>
                 <TextField
                   size="small"
                   {...formik.getFieldProps("position_group")}
                   className={classes.textField}
                 />
               </Grid>
             </Grid>
           </Grid> */}
           
           
           
           <Grid item lg={6} md={6} sm={12} xs={12}>
             <Grid container alignItems="center">
               <Grid item lg={12} md={12} sm={12} xs={12}>
                 <Typography variant="subtitle1">Entry Offset (Minutes)</Typography>
               </Grid>
               <Grid item lg={12} md={12} sm={12} xs={12}>
                 <TextField
                   type="number"
                   placeholder="Entry Offset (Minutes)"
                   size="small"
                   {...formik.getFieldProps("entry_offset_minutes")}
                   className={classes.textField}
                   inputProps={{ min: "0" }}
                 />
               </Grid>
             </Grid>
           </Grid>


           <Grid item lg={6} md={6} sm={12} xs={12}>
  <Grid container alignItems="center">
    <Grid item lg={12} md={12} sm={12} xs={12}>
      <Typography variant="subtitle1">Display Name</Typography>
    </Grid>
    <Grid item lg={12} md={12} sm={12} xs={12}>
      <TextField
        placeholder="Enter Display Name"
        size="small"
        {...formik.getFieldProps("display_name")}
        className={classes.textField}
      />
    </Grid>
  </Grid>
</Grid>

<Grid item lg={12} md={12} sm={12} xs={12}>
  <Grid container alignItems="center">
    <Grid item lg={12} md={12} sm={12} xs={12}>
      <Typography variant="subtitle1">Short Description</Typography>
    </Grid>
    <Grid item lg={12} md={12} sm={12} xs={12}>
      <TextField
        placeholder="Enter Short Description"
        size="small"
        multiline
        rows={2}
        {...formik.getFieldProps("short_description")}
        className={classes.discriptionTextField}
      />
    </Grid>
  </Grid>
</Grid>

<Grid item lg={12} md={12} sm={12} xs={12}>
  <Grid container alignItems="center">
    <Grid item lg={12} md={12} sm={12} xs={12}>
      <Typography variant="subtitle1">Description</Typography>
    </Grid>
    <Grid item lg={12} md={12} sm={12} xs={12}>
      <TextField
        placeholder="Enter Description"
        size="small"
        multiline
        rows={4}
        {...formik.getFieldProps("description")}
        className={classes.discriptionTextField}
      />
    </Grid>
  </Grid>
</Grid>

<Grid item lg={6} md={6} sm={12} xs={12}>
  <Grid container alignItems="center">
    <Grid item lg={12} md={12} sm={12} xs={12}>
      <Typography variant="subtitle1">Pricing Type <span style={{ color: "red" }}>*</span></Typography>
    </Grid>
    <Grid item lg={12} md={12} sm={12} xs={12}>
      <TextField
        select
        fullWidth
        size="small"
        value={formik.values.pricing_type}
        onChange={(e) => formik.setFieldValue("pricing_type", e.target.value)}
      >
        <MenuItem value="">Select Type</MenuItem>
        <MenuItem value="per_person">Per Person</MenuItem>
        <MenuItem value="per_unit">Per Unit</MenuItem>
        <MenuItem value="fixed">Fixed</MenuItem>
      </TextField>
    </Grid>
  </Grid>
</Grid>

{/* <Grid item lg={6} md={6} sm={12} xs={12}>
  <Grid container alignItems="center">
    <Grid item lg={12} md={12} sm={12} xs={12}>
      <Typography variant="subtitle1">Shared Capacity</Typography>
    </Grid>
    <Grid item lg={12} md={12} sm={12} xs={12}>
      <TextField
        type="number"
        placeholder="Shared Capacity"
        size="small"
        {...formik.getFieldProps("shared_capacity")}
        className={classes.textField}
        inputProps={{ min: "0" }}
      />
    </Grid>
  </Grid>
</Grid> */}



<Grid item lg={6} md={6} sm={12} xs={12}>
  <Grid container alignItems="center">
    <Grid item lg={12} md={12} sm={12} xs={12}>
      <Typography variant="subtitle1">Max Date Changes</Typography>
    </Grid>
    <Grid item lg={12} md={12} sm={12} xs={12}>
      <TextField
        type="number"
        size="small"
        {...formik.getFieldProps("max_date_changes")}
        className={classes.textField}
      />
    </Grid>
  </Grid>
</Grid>
           
           
                               <Grid item lg={6} md={6} sm={12} xs={12}>
                                 <Grid container alignItems="center">
                                   <Grid item lg={12} md={12} sm={12} xs={12}>
                                     <Typography variant="subtitle1">Active</Typography>
                                   </Grid>
                                   <Grid item lg={12} md={12} sm={12} xs={12}>
                                     <CustomSwitch
                                       color="primary"
                                       sx={{ mr: 2 }}
                                       formik={formik}
                                       name="isActive"
                                     />
                                   </Grid>
                                 </Grid>
                               </Grid>
           
           

                   

                    

                   




                  </Grid>
                </Card>
              </Grid>



<Grid item lg={12} md={12} sm={12} xs={12} pt={3}>
                  <Card className={classes.card}>
                    <Grid
                      container
                      justifyContent={"space-between"}
                      spacing={5}
                      sx={{ borderBottom: 2, padding: 2 }}
                      className={classes.titleGrid}
                    >
                      <Grid
                        item
                        lg={12}
                        md={12}
                        sm={12}
                        xs={12}
                        pt={2}
                        alignContent={"center"}
                      >
                        <Typography className={classes.cardTitle}>
                        Kids Information
                        </Typography>
                      </Grid>
                    </Grid>

                    <Grid container spacing={3} p={"24px"}>
                    

                  
<Grid item lg={3} md={3} sm={12} xs={12}>
  <Grid container alignItems="center">
    <Grid item lg={12} md={12} sm={12} xs={12}>
      <Typography variant="subtitle1">Min Kids</Typography>
    </Grid>
    <Grid item lg={12} md={12} sm={12} xs={12}>
      <TextField
        type="number"
        size="small"
        {...formik.getFieldProps("min_kids")}
        className={classes.textField}
      />
    </Grid>
  </Grid>
</Grid>

<Grid item lg={3} md={3} sm={12} xs={12}>
  <Grid container alignItems="center">
    <Grid item lg={12} md={12} sm={12} xs={12}>
      <Typography variant="subtitle1">Max Kids</Typography>
    </Grid>
    <Grid item lg={12} md={12} sm={12} xs={12}>
      <TextField
        type="number"
        size="small"
        {...formik.getFieldProps("max_kids")}
        className={classes.textField}
      />
    </Grid>
  </Grid>
</Grid>



<Grid item lg={3} md={3} sm={12} xs={12}>
  <Grid container alignItems="center">
    <Grid item lg={12} md={12} sm={12} xs={12}>
      <Typography variant="subtitle1">Free Kids Included</Typography>
    </Grid>
    <Grid item lg={12} md={12} sm={12} xs={12}>
      <TextField
        type="number"
        size="small"
        {...formik.getFieldProps("free_kids_included")}
        className={classes.textField}
      />
    </Grid>
  </Grid>
</Grid>



<Grid item lg={3} md={3} sm={12} xs={12}>
  <Grid container alignItems="center">
    <Grid item lg={12} md={12} sm={12} xs={12}>
      <Typography variant="subtitle1">Extra Kids Allowed</Typography>
    </Grid>
    <Grid item lg={12} md={12} sm={12} xs={12}>
      <CustomSwitch
        formik={formik}
        name="extra_kids_allowed"
        color="primary"
      />
    </Grid>
  </Grid>
</Grid>



<Grid item lg={3} md={3} sm={12} xs={12}>
  <Grid container alignItems="center">
    <Grid item lg={12} md={12} sm={12} xs={12}>
      <Typography variant="subtitle1">Kid Price</Typography>
    </Grid>
    <Grid item lg={12} md={12} sm={12} xs={12}>
      <TextField
        type="number"
        size="small"
        {...formik.getFieldProps("kid_price")}
        className={classes.textField}
      />
    </Grid>
  </Grid>
</Grid>



<Grid item lg={3} md={3} sm={12} xs={12}>
  <Grid container alignItems="center">
    <Grid item lg={12} md={12} sm={12} xs={12}>
      <Typography variant="subtitle1">Extra Kid Price</Typography>
    </Grid>
    <Grid item lg={12} md={12} sm={12} xs={12}>
      <TextField
        type="number"
        size="small"
        {...formik.getFieldProps("extra_kid_price")}
        className={classes.textField}
      />
    </Grid>
  </Grid>
</Grid>

           



                     
                    </Grid>
                  </Card>
                </Grid>

                <Grid item lg={12} md={12} sm={12} xs={12} pt={3}>
                  <Card className={classes.card}>
                    <Grid
                      container
                      justifyContent={"space-between"}
                      spacing={5}
                      sx={{ borderBottom: 2, padding: 2 }}
                      className={classes.titleGrid}
                    >
                      <Grid
                        item
                        lg={12}
                        md={12}
                        sm={12}
                        xs={12}
                        pt={2}
                        alignContent={"center"}
                      >
                        <Typography className={classes.cardTitle}>
                        Adults Information
                        </Typography>
                      </Grid>
                    </Grid>

                    <Grid container spacing={3} p={"24px"}>
                    

                  
<Grid item lg={3} md={3} sm={12} xs={12}>
  <Grid container alignItems="center">
    <Grid item lg={12} md={12} sm={12} xs={12}>
      <Typography variant="subtitle1">Min Adults</Typography>
    </Grid>
    <Grid item lg={12} md={12} sm={12} xs={12}>
      <TextField
        type="number"
        size="small"
        {...formik.getFieldProps("min_adults")}
        className={classes.textField}
      />
    </Grid>
  </Grid>
</Grid>

<Grid item lg={3} md={3} sm={12} xs={12}>
  <Grid container alignItems="center">
    <Grid item lg={12} md={12} sm={12} xs={12}>
      <Typography variant="subtitle1">Max Adults</Typography>
    </Grid>
    <Grid item lg={12} md={12} sm={12} xs={12}>
      <TextField
        type="number"
        size="small"
        {...formik.getFieldProps("max_adults")}
        className={classes.textField}
      />
    </Grid>
  </Grid>
</Grid>
                      


<Grid item lg={3} md={3} sm={12} xs={12}>
  <Grid container alignItems="center">
    <Grid item lg={12} md={12} sm={12} xs={12}>
      <Typography variant="subtitle1">Free Adults Included</Typography>
    </Grid>
    <Grid item lg={12} md={12} sm={12} xs={12}>
      <TextField
        type="number"
        size="small"
        {...formik.getFieldProps("free_adults_included")}
        className={classes.textField}
      />
    </Grid>
  </Grid>
</Grid>

<Grid item lg={3} md={3} sm={12} xs={12}>
  <Grid container alignItems="center">
    <Grid item lg={12} md={12} sm={12} xs={12}>
      <Typography variant="subtitle1">Extra Adults Allowed</Typography>
    </Grid>
    <Grid item lg={12} md={12} sm={12} xs={12}>
      <CustomSwitch
        formik={formik}
        name="extra_adults_allowed"
        color="primary"
      />
    </Grid>
  </Grid>
</Grid>


<Grid item lg={3} md={3} sm={12} xs={12}>
  <Grid container alignItems="center">
    <Grid item lg={12} md={12} sm={12} xs={12}>
      <Typography variant="subtitle1">Adult Price</Typography>
    </Grid>
    <Grid item lg={12} md={12} sm={12} xs={12}>
      <TextField
        type="number"
        size="small"
        {...formik.getFieldProps("adult_price")}
        className={classes.textField}
      />
    </Grid>
  </Grid>
</Grid>


<Grid item lg={3} md={3} sm={12} xs={12}>
  <Grid container alignItems="center">
    <Grid item lg={12} md={12} sm={12} xs={12}>
      <Typography variant="subtitle1">Extra Adult Price</Typography>
    </Grid>
    <Grid item lg={12} md={12} sm={12} xs={12}>
      <TextField
        type="number"
        size="small"
        {...formik.getFieldProps("extra_adult_price")}
        className={classes.textField}
      />
    </Grid>
  </Grid>
</Grid>


           
           
           
                             </Grid>
                           </Card>
                         </Grid>
           
                         <Grid item lg={12} md={12} sm={12} xs={12} pt={3}>
                           <Card className={classes.card}>
                             <Grid container spacing={3} p={"24px"}>
                               <Grid
                                 item
                                 lg={12}
                                 md={12}
                                 sm={12}
                                 xs={12}
                                 sx={{ display: "flex", justifyContent: "flex-end" }}
                               >
                                 <Button
                                   variant="outlined"
                                   startIcon={<CloseIcon />}
                                   className={classes.addButton}
                                  onClick={() => handleCloseDialog(false)}
                                 >
                                   Cancel
                                 </Button>
                                 <Box m={0.5}></Box>
           
                                 <Button
                                   variant="contained"
                                   startIcon={<SaveAltIcon />}
                                   className={classes.addButton}
                                   onClick={() => formik.handleSubmit()}
                                   disabled={!formValid || isLoading}
                                 >
                                   Save
                                 </Button>
                               </Grid>
                             </Grid>
                           </Card>
                         </Grid>
                       </Grid>
                     </form>
        </Grid>
      </Grid>
      </Grid>
    </Dialog>
  );
};

export default Index;
